<mat-dialog-content class="">
    <h3 class="mb-3"><i class="fas fa-check-circle mr-1"></i> Event PEO</h3>
  
    <div class="container-fluid mt-2">
        <div class="row">
          <div class="col-12 mt-2">
            <div class="table-responsive db-block" style="height: auto !important">
              <i class="fa fa-database mr-2" aria-hidden="true"></i>
              <span>{{ "Event PEO Details" }}</span>
              <table mat-table [dataSource]="dataSource" class="gridData mt-2" matSort>
  
                  <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                      <td mat-cell *matCellDef="let element">{{ element.firstName + ' ' + element.lastName }}</td>
                  </ng-container>

                  <ng-container matColumnDef="emailAddress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                    <td mat-cell *matCellDef="let element">{{ element.emailAddress }}</td>
                  </ng-container>
  
                  <ng-container matColumnDef="phoneNumber">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header>Contact</th>
                      <td mat-cell *matCellDef="let element">{{ element.phoneNumber }}</td>
                  </ng-container>
  
                  <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef>Action</th>
                      <td mat-cell *matCellDef="let element">
                        <button mat-icon-button  matTooltip="Click to Delete" (click)="removePeoFromEvent(element)" class="iconbutton text-danger" data-toggle="modal" data-target="#deletePromptU">
                            <mat-icon aria-label="Delete">delete</mat-icon>
                          </button> 
  
                      </td>
                  </ng-container>
      
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
            <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
          </div>
        </div>
  
      </div>
  
  <mat-dialog-actions align="end">
    <button class="btn btn-danger float-right" (click)="closeDialog()">
      <i class="fas fa-times mr-1"></i> Close
    </button>
  </mat-dialog-actions>
  